// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34HYx","footer":"styles_footer__17zLY"};